import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    padding: '30px 20px 30px 20px',
    width: '850px',
    height: '850px',
    minHeight: '850px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '12px',
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)',
      padding: '15px'
    }
  },
  title: {
    color: '#230B4C',
    fontSize: '22px',
    fontWeight: 'bold',
    width: '100%',
    marginBottom: 24,
    marginLeft: 10
  },
  playlistsContainer: {
    display: 'flex',
    displayDirectio: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: '30px',
    maxHeight: '793px',
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  balloonContainer: {
    transform: 'translateY(-19px)'
  },
  playlistName: {
    fontWeight: 500,
    color: '#FFF',
    fontSize: 20,
    lineHeight: 1,
    background: 'transparent',
    paddingLeft: 0,
    paddingTop: 7,
    maxHeight: 120,
    wordBreak: 'break-word',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 5
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px #e1dddd',
      borderRadius: 10
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#FFF',
      borderRadius: 10
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(255, 255, 255, 0.6)'
    }
  },
  playlistItemWrapper: {
    marginBottom: '15px'
  }
}))
